<ng-container *ngIf="project && project.custom">
    <!-- THUMBNAILS -->
    <td class="w-[5%]" *ngIf="proofreadings.length">
        <img class="thumb" [style.height]="'calc(2.5rem*'+proofreadings.length+')'" [src]="thumbnail | async" />
    </td>
    <td class="w-[5%]" *ngIf="!proofreadings.length">
        <img class="thumb" [style.height]="'2.5rem*'" [src]="thumbnail | async" />
    </td>
    <!-- NAME -->
    <td class="w-[20%] p-2">
        <!-- <a [routerLink]="[isCPP() || isFab() ? '/project/edit/': '/project/', project._id]" matTooltip="{{ (isCPP() || isFab() ?  'DASHBOARD.UPDATE_JOB' : 'DASHBOARD.BRIEF') | translate }}" class="flex items-center justify-start w-full min-h-[3em]"> -->
        <button *ngIf="project.custom.general" class="text-left flex items-center justify-center" (dblclick)="copyToClipboard(project.name)" matTooltip="{{ project.name }} - {{ project.custom.general.designation }} {{
                project.custom.general.id_codearticle ? ' - ' + project.custom.general.id_codearticle : '' }}" matTooltipShowDelay="800" matTooltipClass="single-tooltip">
            <span class="truncate-text">{{ project.name }} - {{ project.custom.general.designation }} {{ project.custom.general.id_codearticle ? ' - ' + project.custom.general.id_codearticle : '' }}</span>
        </button>
        <!-- </a> -->
    </td>
    <!-- EasyDiadem  -->
    <td class="w-[5%]">
        <div class="flex items-center justify-center gap-2">
            <div class="justify-center items-center" *ngIf="project.custom.general.is_old"><mat-icon class="!flex text-[1.8rem] mt-[-0.1rem]" color="black" svgIcon="folder-limited" [matTooltip]=" 'OLD_PROJECT' | translate "></mat-icon></div>
            <div class="justify-center items-center" *ngIf="archived"><mat-icon class="!flex text-[1.8rem] mt-[-0.1rem]" [matTooltip]=" 'ARCHIVED' | translate ">archive</mat-icon></div>
            <div class="flex flex-col">
                <div class="flex min-h-[3em] items-center justify-center" *ngFor="let proofreading of proofreadings">
                    <a class="block flex-col easydiadem" *ngIf="proofreading.request" [href]="'/#/easydiadem/dashboard?ref='+proofreading.request.ref"><img class="w-[1.6rem] h-[1.6rem]" [matTooltip]="proofreading.request.ref || ''" src="assets/svg/ed.svg" alt="logo-easydiadem" /></a>
                </div>
            </div>
        </div>
    </td>
    <!-- FLOWS  -->
    <td class="w-[5%]">
        <div class="flex flex-col align-top justify-center">
            <div class="flex flow-type min-h-[3em] border-b-grey align-middle" *ngFor="let flow of available_flows">
                <div class="h-fit !self-center">{{ flow | uppercase | translate }}</div>
            </div>
        </div>
    </td>
    <!-- EXTERN_STATE -->
    <td class="w-[15%] states">
        <ng-container *ngIf="proofreadings?.length; else noProofreadings">
            <div class="flex justify-between align-middle bg-gray-300 bg-opacity-20">
                <div class="flex flex-col align-top justify-center flex-grow">
                    <div *ngFor="let proofreading of proofreadings">
                        <ng-container *ngIf="proofreading?.flow !== flowType.BAT ; else bat">
                            <div class="extern-status flex pl-4 pr-1 border-b-white min-h-[3em]">
                                <div class="flex justify-between align-middle h-fit !self-center">
                                    <div class='w-[10em] flex gap-2'>
                                        <div class="flex items-center gap-2 bold italic" [ngClass]="[getSlugText(proofreading?.state?.slug, false, proofreading), getFeedBackClient(proofreading)]">
                                            <div class="size-3 rounded-lg" [ngClass]="['bg-'+getSlugText(proofreading?.state?.slug, false, proofreading), 'bg-' + getFeedBackClient(proofreading)]">
                                            </div> <span>{{ "EXTERN.DASHBOARD." + getSlugText(proofreading?.state?.slug, false, proofreading) | uppercase | translate }}</span>
                                        </div>
                                    </div>
                                    <div class="bg-tw-text-light text-tw-blue border-tw-blue ml-3 border-[1px] flex align-middle justify-center w-[2em] h-[2em]">
                                        <div class="flex leading-[2em]"> {{ getPrefixRelecture(proofreading.flow).short }}{{ proofreading.relecture }} </div>
                                    </div>
                                </div>
                                <!-- SEE EXTERN HISTORY -->
                            </div>
                        </ng-container>
                        <ng-template #bat>
                            <div class="extern-status flex pl-4 pr-1 border-b-white min-h-[3em]" [ngClass]="['bg-'+getSlugText(proofreading.state.slug, false, proofreading)]">
                                <div class="flex justify-between align-middle h-fit !self-center">
                                    <div class='w-[10em] flex gap-2'>
                                        <div class="flex items-center gap-2 bold italic" [ngClass]="[getFeedBackClient(proofreading)]">
                                            <div class="size-3 rounded-lg bg-white"></div>
                                            <span>{{ "EXTERN.DASHBOARD." + getSlugText(proofreading.state.slug, false, proofreading) | uppercase | translate }}</span>
                                        </div>
                                    </div>
                                    <div class="bg-tw-text-light text-tw-blue border-tw-blue ml-3 border-[1px] flex align-middle justify-center w-[2em] h-[2em]">
                                        <div class="flex leading-[2em]"> {{ getPrefixRelecture(proofreading.flow).short }}{{ proofreading.relecture }} </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
                <button class="flex justify-center items-center w-[5em]" (click)="openProjectHistory()" [matTooltip]="'SEE_PROJECT_HISTORY' | translate"><mat-icon class="text-tw-mediumgrey">history</mat-icon></button>
            </div>
        </ng-container>
        <ng-template #noProofreadings>
            <div class="flex h-[3em] justify-around items-middle bg-gray-300 bg-opacity-20">
                <ng-container *ngIf="!project.custom.general.is_old; else isOld">
                    <button *ngIf="isCPP()" class="flex px-[0.4em] justify-center items-center rounded-md !border-tw-primary !border-[1px] text-tw-primary" (click)="openCreateProofreadingModal(project)">
                        <mat-icon>add</mat-icon>
                        <span class="leading-[0.4em] p-1">{{ "CREATE_PROOFREADING" | translate }}</span>
                    </button>
                    <span *ngIf="!isCPP()" class="self-center">{{ "NO_PROOFREADING" | translate }}</span>
                </ng-container>
                <ng-template #isOld>
                    <button disabled class="flex px-[0.4em] justify-center items-center rounded-md !border-tw-primary !border-[1px] text-tw-primary opacity-60">
                        <mat-icon>cancel</mat-icon>
                        <span class="leading-[0.4em] p-2">{{ "OLD_PROJECT_NO_PR" | translate | uppercase }}</span>
                    </button>
                    <ng-container *ngIf="isClient()">
                        <a target="_blank" [routerLink]="['/splitview/old', project._id]">
                            <button class="text-tw-primary hover:text-blue-400" mat-icon-button [disableRipple]="true" matTooltip="{{ 'DASHBOARD.PREVIEW' | translate }}">
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </a>
                    </ng-container>
                </ng-template>
            </div>
        </ng-template>
    </td>
    <!-- INTERN_STATE -->
    <td *ngIf="!isClient()" class="w-[15%] states">
        <div class="flex justify-between align-middle bg-tw-complementary">
            <div class="flex flex-col align-top justify-center flex-grow">
                <div class="flex border-b-white min-h-[3em]" *ngFor="let proofreading of proofreadings">
                    <div class="flex justify-between align-middle h-fit !self-center">
                        <div class="state-color-rect min-h-[3em]" [ngClass]="'bg-'+getSlugText(proofreading.intern?.currentState?.slug, true, proofreading)">
                        </div>
                        <div class="flex flex-col gap-1 h-fit !self-center ml-2">
                            <div *ngIf="dislayInternPr(proofreading)" class=" text-tw-text-disabled italic">{{ "INTERN.DASHBOARD." + getSlugText(proofreading.intern?.currentState?.slug, true, proofreading) | uppercase | translate }}</div>
                            <div *ngIf="!dislayInternPr(proofreading)" matTooltip="{{getFileName(proofreading)?.fileName}}" class="text-sm text-tw-text-disabled italic cursor-default">{{ getFileName(proofreading)?.shortFileName }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- SEE INTERN HISTORY -->
            <!-- <button class="w-[5em]" (click)="openProjectHistory()"><mat-icon class="text-tw-mediumgrey">visibility</mat-icon></button> -->
        </div>
    </td>
    <!-- RELECTURE MEMBERS -->
    <td *ngIf="isClient()">
        <ng-container *ngFor="let proofreading of proofreadings">
            <ng-container *ngIf="displayPrStatus(proofreading); else noPRStatus">
                <div class="flex flex-col border-r-[1px] border-dashed bg-tw-complementary">
                    <div class="flex gap-2 border-b-white justify-start items-center min-h-[3em] pl-4">
                        <span [className]="'rounded-full w-3 h-3 bg-' + proofreading.main_member?.status || ''"></span>
                        <span class="font-extrabold italic">{{ ('MEMBERS_STATUS.' + proofreading.main_member?.status) | uppercase | translate}}</span>
                    </div>
                </div>
            </ng-container>
            <ng-template #noPRStatus>
                <div class="border-r-[1px] border-dashed">
                    <div class="border-b-white min-h-[3em] pl-4">
                    </div>
                </div>
            </ng-template>
        </ng-container>
    </td>
    <!-- LINKS -->
    <td>
        <div class="flex flex-col">
            <div class="flex border-b-grey justify-start items-center min-h-[3em] gap-1" *ngFor="let proofreading of proofreadings">
                <a *ngIf="!isClient() && proofreading.intern" [routerLink]="['/splitview/intern', proofreading._id]">
                    <button class="ml-2 relecture-btn" (click)="filterProjectStorage(project)">
                        <mat-icon svgIcon="check-mark" class="!size-3"></mat-icon>
                        <span class="leading-3">{{ "INTERN_TITLE" | translate }}</span>
                    </button>
                </a>
                <a [routerLink]="['/splitview', proofreading._id]">
                    <button class="ml-2 relecture-btn" (click)="filterProjectStorage(project)">
                        <mat-icon svgIcon="visibility" class="!size-3"></mat-icon>
                        <span class="leading-3">{{ proofreading.flow === flowType.BAT ? ('VIEW.BUTTON' | translate ) : (isClient() ? 'RELECTURE_EXTERN' : 'EXTERN_TITLE') | translate }}</span>
                    </button>
                </a>
                <div *ngIf="isClient() && !dislayInternPr(proofreading)" matTooltip="{{getFileName(proofreading)?.fileName}}" class="text-sm text-tw-text-disabled italic cursor-default">{{ getFileName(proofreading)?.shortFileName }}</div>
            </div>
        </div>
    </td>
    <!-- CREATION DATE -->
    <td class="w-[10%]">
        <div class="flex flex-col items-start justify-center w-full px-4">
            <span class="font-normal text-sm">{{ project.birth | date : "dd-MM-yyyy" }}</span>
            <span *ngIf="project.custom.general_info.cpp" class="flex justify-start items-center gap-1"><img class="size-3" src="assets/svg/awe-user-circle.svg" /><span class="font-extralight text-xs italic self-center">{{ project.custom.general_info.cpp.fullname }}</span></span>
        </div>
    </td>
    <!-- ACTIONS -->
    <td *ngIf="!isClient()" class="w-[10%]">
        <div class="flex justify-start">
            <ng-container *ngIf="!project?.custom?.general?.is_old; else old_project">
                <!-- NOT OLD -->
                <div *ngIf="isOperator() && proofreadings[0]?.intern && !archived">
                    <a [routerLink]="['/splitview/intern/revisions/', proofreadings[0]._id, projectID]" target="_blank">
                        <button class="text-tw-primary hover:text-blue-400" (click)="filterProjectStorage(project)" mat-icon-button [disableRipple]="true" matTooltip="{{ 'COMPARE' | translate }}">
                            <!-- <span class="icon-icons_compare mat-icon text-3xl"></span> -->
                            <mat-icon svgIcon="compare" class="!size-6"></mat-icon>
                        </button>
                    </a>
                </div>
                <a [routerLink]="[isCPP() || isFab() ? '/project/edit/': '/project/', project._id]">
                    <button class="text-tw-primary hover:text-blue-400" (click)="filterProjectStorage(project)" mat-icon-button [disableRipple]="true" matTooltip="{{ (isCPP() || isFab() ?  'DASHBOARD.UPDATE_JOB' : 'DASHBOARD.BRIEF') | translate }}">
                        <mat-icon svgIcon="awe-file" class="!size-6"></mat-icon>
                    </button>
                </a>
            </ng-container>
            <ng-template #old_project>
                <ng-container *ngIf="!proofreadings?.length" >
                <a target="_blank" [routerLink]="['/splitview/old', project._id]">
                    <button class="text-tw-primary hover:text-blue-400" (click)="filterProjectStorage(project)" mat-icon-button [disableRipple]="true" matTooltip="{{ 'DASHBOARD.PREVIEW' | translate }}">
                        <!-- <span class="icon-splitview text-3xl"></span> -->
                        <mat-icon svgIcon="splitview" class="!size-6"></mat-icon>
                    </button>
                </a>
            </ng-container>
            </ng-template>
            <button *ngIf="!project?.custom?.general?.is_webcenter" class="text-tw-primary hover:text-blue-400" mat-icon-button [disableRipple]="true" (click)="project.custom && project.custom.general && project.custom.general.is_old ? openFolderOld(project) : openFolderChild(project)" matTooltip="{{ 'DASHBOARD.FOLDER' | translate }}">
                <mat-icon svgIcon="awe-folder" class="!size-6"></mat-icon>
            </button>
            <ng-container *ngIf="isCPP() && !project?.custom?.general?.is_old">
                <a>
                    <button class="text-tw-primary hover:text-blue-400" (click)="filterKpi(project)" mat-icon-button matTooltip="{{ 'DASHBOARD.STATS' | translate }}">
                        <mat-icon svgIcon="kpi" class="!size-6"></mat-icon>
                    </button>
                </a>
            </ng-container>
        </div>
    </td>
</ng-container>